import React from "react";

const LabelComp = ({ label, value, showReadOnly = false, className = "" }) => {
  const hasValue = value !== undefined && value !== null && value !== "";

  return (
    <div
      className={`flex flex-col border rounded-[15px] px-[10px] py-[5px] pb-[7px] ${className}`}
    >
      <div className="flex items-center gap-2">
        <span className="text-[11px] font-medium text-slate-500 uppercase tracking-wide mt-[-12px] bg-white px-1">
          {label}
        </span>

        {showReadOnly && (
          <span className="text-[10px] px-2 py-[2px] rounded-full bg-slate-100 text-slate-500 font-medium">
            Read only
          </span>
        )}
      </div>

      <span
        className={`text-[15px] font-medium ${
          hasValue ? "text-slate-600" : "text-slate-400"
        }`}
      >
        {hasValue ? value : "—"}
      </span>
    </div>
  );
};

export default LabelComp;
